import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from '../views/Login.vue'

const routes = [
  // {
  //   path: '/',
  //   redirect: '/asr', // 重定向根路径到/asr  
  // },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    props: true // 启用 props 接收参数
  },
  {
    path: '/dialogue',
    name: 'dialogue',
    component: () => import(/* webpackChunkName: "about" */ '../views/Dialogue.vue'),
    props: true // 启用 props 接收参数
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: true // 启用 props 接收参数
  }
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes,
  // redirect: { path: '/asr' }
})

export default router
